// FludeeHero.jsx
// ✅ Same design hero section (gradient + chip pulse + responsive title)
// ✅ Bottom note REMOVED
// Requires: @mui/material @emotion/react @emotion/styled

import * as React from "react";
import {
  Box,
  Container,
  Stack,
  Chip,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha, useTheme, keyframes } from "@mui/material/styles";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import { Link } from "react-router-dom";

const pulseZoom = keyframes`
  0%   { transform: scale(1);   box-shadow: 0 10px 22px rgba(0,0,0,0.12); }
  50%  { transform: scale(1.08); box-shadow: 0 16px 30px rgba(0,0,0,0.22); }
  100% { transform: scale(1);   box-shadow: 0 10px 22px rgba(0,0,0,0.12); }
`;

export default function FludeeHero({
  badge = "Launching Soon",
  title = "FLUDEE",
  subtitle = "Smart Fluid  Management Software Device",
  tagline = "Fluid logisitic urine output Device Equilibrium Efficiency",
  ctaText = "Get Early Access",
  secondaryText = "View Roadmap",
  onCtaClick,
  onSecondaryClick,
  showActions = true,
}) {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        py: { xs: 6, sm: 7, md: 10 },
        textAlign: "center",
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
        background: `linear-gradient(
          180deg,
          ${alpha("#38bdf8", 0.45)} 0%,
          ${alpha("#e0f2fe", 1)} 60%,
          ${alpha(theme.palette.background.default, 1)} 100%
        )`,
      }}
    >
      <Container>
        <Stack spacing={2} alignItems="center">
          <Chip
            icon={<LaunchRoundedIcon />}
            label={badge}
            sx={{
              fontWeight: 900,
              px: 1.6,
              py: 0.8,
              borderRadius: 999,
              backgroundColor: "#facc15",
              color: "#0b1220",
              border: `1px solid ${alpha("#0b1220", 0.18)}`,
              animation: `${pulseZoom} 1.6s ease-in-out infinite`,
              "& .MuiChip-icon": { color: "#0b1220" },
            }}
          />

          <Typography
            variant="h2"
            sx={{
              fontWeight: 900,
              letterSpacing: -0.5,
              fontSize: { xs: 34, sm: 44, md: 56 },
              lineHeight: 1.05,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              color: alpha("#0b1220", 0.75),
              fontWeight: 700,
              fontSize: { xs: 14.5, sm: 16 },
            }}
          >
            {subtitle}
          </Typography>

          <Typography
            sx={{
              color: alpha("#0b1220", 0.68),
              maxWidth: 760,
              lineHeight: 1.7,
              fontSize: { xs: 13.5, sm: 14.5, md: 15.5 },
              px: { xs: 1, sm: 0 },
            }}
          >
            {tagline}
          </Typography>

          {showActions && (
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              sx={{ pt: 1 }}
            >
              <Button
                variant="contained"
                size={isSmUp ? "large" : "medium"}
                endIcon={<ArrowForwardRoundedIcon />}
                onClick={onCtaClick}
                sx={{
                  borderRadius: 999,
                  px: 3,
                  py: 1.2,
                  fontWeight: 900,
                  textTransform: "none",
                }}
              >
                {ctaText}
              </Button>

              {/* Secondary Link Button */}
              <Link
                to="/Addpages"
                onClick={handleScrollTop}
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="outlined"
                  size={isSmUp ? "large" : "medium"}
                  onClick={onSecondaryClick}
                  sx={{
                    borderRadius: 999,
                    px: 3,
                    py: 1.2,
                    fontWeight: 900,
                    textTransform: "none",
                    borderColor: alpha("#0b1220", 0.18),
                    color: alpha("#0b1220", 0.88),
                    backgroundColor: alpha("#ffffff", 0.6),
                    backdropFilter: "blur(8px)",
                    "&:hover": {
                      borderColor: alpha("#0b1220", 0.26),
                      backgroundColor: alpha("#ffffff", 0.8),
                    },
                  }}
                >
                  {secondaryText}
                </Button>
              </Link>
            </Stack>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
